import { Controller } from "@hotwired/stimulus"

// Native shell only (mobile layouts put it on <body> for the app). The
// keyboard has no Done button above it there (no accessory bar) and a
// textarea's return key inserts a newline, so a tap or drag anywhere
// outside the textarea being edited drops the keyboard — the way Messages
// and Notes behave. Single-line fields keep their return-key behavior and
// aren't touched, so the organization picker's tap-to-select still works.
export default class extends Controller {
  connect() {
    this.onTouchStart = (event) => {
      const active = document.activeElement
      if (!active || active.tagName !== "TEXTAREA") return
      if (active.contains(event.target)) return
      // The composer's own controls (attach, send, the pill around them)
      // belong to the keyboard session: dropping it there shifts the layout
      // under the native file picker and the send tap.
      if (active.form && active.form.contains(event.target)) return
      active.blur()
    }
    document.addEventListener("touchstart", this.onTouchStart, { passive: true })
  }

  disconnect() {
    document.removeEventListener("touchstart", this.onTouchStart)
  }
}
